/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const staticCss = ({ color }) => css`
  border-bottom: 1px solid ${color.border};
  padding: 16px;
`;

export const CardHeader = ({ children, ...rest }) => (
  <header {...rest} css={staticCss}>
    {children}
  </header>
);

CardHeader.propTypes = {
  children: PropTypes.node.isRequired,
};
